<template>
  <div>
    <!-- 进行中的配送单 -->
    <baseBreadcrumb :page="$t('message.underwayPorder')" :menu="$t('message.porder')" />
    <section>
      <div class="header">
        <div class="headerContainer">
          <!-- 状态切换 -->
          <div class="tabs">
            <el-tabs v-model="datas.status" type="card" @tab-click="handleClick">
              <!--  全部-->
              <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
              <!--  待翻译-->
              <el-tab-pane v-for="(item, index) in statusList" :key="index" :label="item.value"
                :name="item.key + ''"></el-tab-pane>
            </el-tabs>
          </div>
          <!-- 搜索 -->
          <div class="operationContainer">
            <div class="item">
              <el-date-picker v-model="datas.dateStart" type="date" :placeholder="$t('message.startDate')"
                value-format="yyyy-MM-dd" clearable>
              </el-date-picker>
            </div>
            <div class="item">
              <el-date-picker type="date" v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')"
                value-format="yyyy-MM-dd" clearable>
              </el-date-picker>
            </div>
            <!-- 物流号 -->
            <div class="item">
              <el-input v-model="datas.express_no" clearable :placeholder="$t('message.pleaseEnterTheLogisticsNumber')"
                onfocus="this.select()"></el-input>
            </div>
            <!-- 请输入配送单号 -->
            <div class="item">
              <el-input v-model="datas.porder_sn" clearable :placeholder="$t('message.pleaseEnterTheShippingNumber')"
                onfocus="this.select()"></el-input>
            </div>
            <!-- 客户ID -->
            <div class="item">
              <el-input v-model="datas.user_id" clearable :placeholder="$t('message.clientID')"
                onfocus="this.select()"></el-input>
            </div>
            <!-- 配送单类别 -->
            <div class="item">
              <el-select v-model="datas.porder_type" clearable filterable :placeholder="$t('message.porderType')">
                <el-option v-for="item in porder_type" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- 客户属性 -->
            <div class="item">
              <el-select v-model="datas.user_type" clearable filterable :placeholder="$t('message.customerProperty')">
                <el-option v-for="item in user_type" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- 订单展开或者收起 -->
            <div class="operation">
              <el-button type="success" @click="isMaxHeight = !isMaxHeight">{{ isMaxHeight ? $t('message.orderExpand') :
                $t('message.orderCollapse') }}</el-button>
            </div>
          </div>
          <div class="operationContainer">
            <!--人员范围-->
            <div class="item">
              <!--  人员范围-->
              <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
            </div>
            <div class="item">
              <!--  全体人员-->
              <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="item">
              <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
                <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 业务 -->
            <div class="item">
              <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货员 -->
            <div class="item">
              <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
                <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="item">
              <!-- 筛选 -->
              <el-button type="primary" @click="search">{{
                $t("message.filter")
              }}</el-button>
              <!-- 重置 -->
              <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
            </div>
            <div class="operation">
              <!-- 配送单删除 -->
              <el-button type="primary" v-if="isAuth(477)" @click="deliveryOrderDeletion">{{
                $t("message.deliveryOrderDeletion")
              }}</el-button>
              <!-- 跨组调整配送单 -->
              <el-button type="primary" class="primary" v-if="isAuth(660)" @click="crossGroupDeliveryOrder">{{
                $t("message.crossGroupDeliveryOrderAdjustment")
              }}</el-button>
              <!-- 调整业务 -->
              <el-button type="primary" @click="allot('y')" class="primary" v-if="isAuth(221)">{{
                $t("message.adjustBusiness")
              }}</el-button>
              <!-- 调整配货 -->
              <el-button type="primary" @click="allot('p')" class="primary" v-if="isAuth(222)">{{
                $t("message.adjustTheDistribution")
              }}</el-button>
              <!-- 分配业务，采购，配货 -->
              <!--  回退待入金-->
              <!-- <el-button type="primary" @click="$message.error('暂无开放此功能')">{{ $t("message.withdrawRemaining")
              }}</el-button> -->

            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footerContainer">
          <!-- 表格 -->
          <div class="table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#EDEFF4' }"
              @cell-click="labelSelection" ref="multipleTable" @selection-change="handleSelectionChange" size="small">
              <el-table-column prop="rowNumber" label="NO" width="60" align="center">
              </el-table-column>
              <!-- 选择 -->
              <el-table-column type="selection" width="60" align="center">
              </el-table-column>
              <!-- 配送单号 -->
              <el-table-column align="center" :label="$t('message.porderNumber')" width="180px">
                <template slot-scope="scope">
                  <p v-if="scope.row.from_porder_sn">
                    原: <router-link :to="'/porderDetail?porder_sn=' + scope.row.from_porder_sn" target="_blank"
                      style="color: rgba(180, 39, 45, 0.5);">
                      {{ scope.row.from_porder_sn }}
                    </router-link>
                  </p>
                  <p class="oneself">
                    <router-link
                      :to="scope.row.status != 10 ? '/porderDetail?porder_sn=' + scope.row.porder_sn : '/deliveryPreview?porder_sn=' + scope.row.porder_sn"
                      target="_blank">
                      {{ scope.row.porder_sn }}</router-link>
                    <!-- 显示废弃 -->
                    <span class="discard" v-if="scope.row.discard_status">废</span>
                  </p>
                  <p>
                    <router-link
                      :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
                      target="_blank" style="color:#606266 ">
                      {{ scope.row.user.realname }}
                    </router-link>
                    <img src="@/assets/icon/illegal.png" alt="" slot="reference"
                      style="vertical-align: middle; width: 30px;" v-if="scope.row.user.user_tag != false">
                  </p>
                </template>
              </el-table-column>
              <!-- 订单号 -->
              <el-table-column align="center" :label="$t('message.orderNumber')" width="180px">
                <template slot-scope="scope">
                  <div class="orderList" :style="{ maxHeight: isMaxHeight ? '200px' : '10000px' }">
                    <p v-for="(item, index) in scope.row.porder_detail" :key="index">
                      <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank">
                        {{ item.order_sn }}
                      </router-link>
                    </p>
                  </div>
                </template>
              </el-table-column>
              <!-- 操作员 -->
              <el-table-column align="center" :label="$t('message.operator')" width="120">
                <template slot-scope="scope">
                  <div>
                    <span>{{ $t("message.salesman") }}:</span>{{ scope.row.y_admin != null ? scope.row.y_admin.realname
                      :
                      '' }}
                  </div>
                  <div>
                    <span>{{ $t("message.buyer") }}:</span>{{ scope.row.g_admin != null ? scope.row.g_admin.realname :
                      ''
                    }}
                  </div>
                  <div>
                    <span>{{ $t("message.distributionMember") }}:</span>{{ scope.row.p_admin != null ?
                      scope.row.p_admin.realname : '' }}
                  </div>
                </template>
              </el-table-column>
              <!-- 配送单状态 -->
              <el-table-column align="center" :label="$t('message.porderStatus')" prop="statusName">
                <template slot-scope="scope">
                  <p>{{ scope.row.statusName }}</p>
                  <el-tooltip class="item" effect="dark" :content="scope.row.user.realname" placement="right"
                    v-if="scope.row.created_by_admin == null">
                    <span class="name">
                      客户
                    </span>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="scope.row.created_by_admin.realname"
                    placement="right" v-else>
                    <span class="name">
                      业务
                    </span>
                  </el-tooltip>
                  <!-- 亚马逊标识 -->
                  <p> <img src="@/assets/img/Amazon.png" alt="" style="width: 80px;" v-if="scope.row.is_amazon"></p>

                </template>
              </el-table-column>
              <!--  导出excel-->
              <el-table-column align="center" label="导出excel" width="75">
                <template slot-scope="scope">
                  <a :href="baseURL + '/download.porderDetailDownload?porder_sn=' + scope.row.porder_sn" target="_blank"
                    rel="noopener noreferrer">
                    <i class="el-icon-download" style="font-size: 30px;">
                    </i>
                  </a>
                </template>
              </el-table-column>
              <!-- 配送单提交 -->
              <el-table-column align="center" :label="$t('message.porderSubmit')" width="76" prop="created_at">
              </el-table-column>
              <!-- 配送单翻译 -->
              <el-table-column align="center" :label="$t('message.porderTranslate')" width="76"
                prop="porder_time_node.datetime_translate">
              </el-table-column>
              <!-- 配送单装箱 -->
              <el-table-column align="center" :label="$t('message.porderEncasement')" width="76"
                prop="porder_time_node.datetime_confirm">
              </el-table-column>
              <!-- 配送单报价 -->
              <el-table-column align="center" :label="$t('message.porderQuote')" width="76"
                prop="porder_time_node.datetime_offer">
              </el-table-column>
              <!-- 客户付款 -->
              <el-table-column align="center" :label="$t('message.customerPayment')" width="76"
                prop="porder_time_node.datetime_pay_submit">
              </el-table-column>
              <!-- 财务确认到账 -->
              <el-table-column align="center" :label="$t('message.financialConfirmationCoTheAccount')" width="140"
                prop="porder_time_node.datetime_pay_confirm">
              </el-table-column>
              <!-- 业务出货 -->
              <el-table-column align="center" :label="$t('message.businessShip')" width="76"
                prop="porder_time_node.datetime_delivery">
              </el-table-column>
              <!-- 客户签收 -->
              <el-table-column align="center" :label="$t('message.userSignFor')" width="76"
                prop="porder_time_node.datetime_client_receive">
              </el-table-column>
              <!-- 取消 -->
              <el-table-column align="center" :label="$t('message.cancel')" width="76"
                prop="porder_time_node.datetime_cancel">
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="paginationContainer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="datas.page" :page-sizes="[50, 80, 100, 200]" :page-size="datas.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </section>
    <!-- 调整配送单 -->
    <adjustment ref="adjustment" />
    <!-- 跨组调整配送单 -->
    <crossGroupDeliveryOrder ref="crossGroupDeliveryOrder" />
    <!--  填写删除原因" -->
    <el-dialog :title="$t('message.enterReasonForDeletion')" :close-on-click-modal="false"
      :visible.sync="delDialogVisible" width="400px" center>
      <div class="textarea">
        <el-input type="textarea" v-model="delete_reason" show-word-limit resize="none" onfocus="this.select()">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="danger" @click="deletePorder">{{
          $t("message.delete")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import adjustment from './components/adjustment'
import crossGroupDeliveryOrder from './components/crossGroupDeliveryOrder'
export default {
  components: {
    adjustment,
    crossGroupDeliveryOrder
  },
  data() {
    return {
      isMaxHeight: true,
      statusList: [],
      status: "underway",
      datas: {
        page: 1,
        pageSize: 50,
        dateStart: "",
        dateEnd: "",
        logistics: "",
        porder: "",
        user_id: "",
        y_id: "",
        g_id: "",
        p_id: "",
        org_id: "",
        admin_id: "",
      },
      total: 0,
      tableData: [],
      dialogVisibleTitle: "",
      allotVal: "",
      dialogVisible: false,
      allotOptions: [],
      selectList: [],
      userList: [],
      user_type: [
        {
          value: 'PAY',
          label: '付费客户',
        },
        {
          value: 'VIP',
          label: 'vip客户',
        },
        {
          value: 'NORMAL',
          label: '普通客户',
        },
      ],
      porder_type: [
        {
          value: 'NORMAL',
          label: '普通',
        },
        {
          value: 'AUTHORIZED',
          label: '授权',
        },
        {
          value: 'FBA',
          label: 'FBA',
        },
      ],
      delDialogVisible: false,//删除弹框
      delete_reason: '',// 删除原因

    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },

  },
  created() {
    if (this.$route.query.user_id) {
      this.datas.user_id = this.$route.query.user_id
    }
    this.porderList();
    this.$api.porderApi.statusMap().then((res) => {
      this.statusList = res.data;
    });
  },
  methods: {

    handleClose(done) {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    handleClick() {
      this.datas.page = 1;
      this.porderList();
    },
    // 选中项
    handleSelectionChange(val) {
      this.selectList = val;
    },
    porderList() {
      this.$api.porderApi.porderList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.tableData.forEach((list) => {
          // 数组去重
          var hash = {};
          list.porder_detail = list.porder_detail.reduce(function (item, next) {
            hash[next.order_sn]
              ? ""
              : (hash[next.order_sn] = true && item.push(next));
            return item;
          }, []);
        });
        this.total = res.data.total;
        // console.log(res.data.data);
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.porderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.porderList();
    },
    //搜索
    search() {
      this.datas.page = 1;
      this.porderList();
    },
    reset() {
      this.datas = {
        page: 1,
        pageSize: 50,
        dateStart: "",
        dateEnd: "",
        logistics: "",
        porder: "",
        user_id: "",
        y_id: "",
        g_id: "",
        p_id: "",
      };
      this.$refs.cascader.orgId = [];
      this.porderList();
    },
    //显示分配弹框
    allot(type) {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.adjustment.allotType = type;
      if (type == "y") {
        this.$refs.adjustment.allotOptions = this.y;
        this.$refs.adjustment.dialogVisibleTitle = this.$t("message.adjustBusiness");
        if (this.selectList.length == 1) {
          this.$refs.adjustment.allotVal = this.selectList[0].y_admin ? this.selectList[0].y_admin.id : ''
        } else {
          this.$refs.adjustment.allotVal = ''
        }
      } else if (type == "p") {
        this.$refs.adjustment.allotOptions = this.p;
        this.$refs.adjustment.dialogVisibleTitle = this.$t("message.distribution");
        if (this.selectList.length == 1) {
          this.$refs.adjustment.allotVal = this.selectList[0].p_admin ? this.selectList[0].p_admin.id : ''
        } else {
          this.$refs.adjustment.allotVal = ''
        }
      }
      this.$refs.adjustment.dialogVisible = true;
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 显示配送单弹框
    deliveryOrderDeletion() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.selectList.length > 1)
        return this.$message.error('只能单个删除配送单');
      this.delete_reason = ''
      this.delDialogVisible = true
    },
    //配送单删除
    deletePorder() {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.save"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            porder_sn: this.selectList[0].porder_sn,
            delete_reason: this.delete_reason
          }
          this.$api.porderApi.deletePorder(datas).then((res) => {
            this.$message.success(res.msg);
            this.delDialogVisible = false
            this.porderList();
          });
        })
        .catch(() => { });
    },
    // 跨组调整配送单
    crossGroupDeliveryOrder() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.crossGroupDeliveryOrder.dialogVisible = true;
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

section {
  padding-top: 0px !important;

  .operationContainer {
    display: flex;
    flex-wrap: wrap;

    .item {
      margin-right: 12px;
    }

    position: relative;

    .operation {
      position: absolute;
      top: 0px;
      right: 0;
    }
  }

  .headerContainer {
    /deep/.el-input__inner {
      width: 180px;
    }
  }


  .el-date-editor {
    width: 180px;
  }
}

.tabs {
  margin-top: 20px;
}

.table {
  .name {
    font-size: 20px;
    color: #b4272d;
  }

  .orderList {
    overflow-y: auto;
  }
}



a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}

.oneself {
  position: relative;

  .discard {
    display: inline-block;
    background-color: #b4272d;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
  }
}
</style>